import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "page-footer",
  role: "contentinfo"
}
const _hoisted_2 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_3 = {
  key: 1,
  class: "badge badge-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex align-items-center flex-1 text-muted" }, [
      _createElementVNode("span", { class: "hidden-md-down fw-700" }, [
        _createTextVNode("2026 フュージョンアウトドア by "),
        _createElementVNode("a", {
          href: "https://fusion-outdoor.co.jp/",
          class: "text-primary fw-500",
          title: "https://fusion-outdoor.co.jp/",
          target: "_blank"
        }, "https://fusion-outdoor.co.jp/")
      ]),
      _createElementVNode("span", {
        "data-ver": "ver 20261006042948",
        class: "hidden-md-down fw-700",
        style: {"margin-left":"20px"}
      }, "v 3.0.0")
    ], -1)),
    _createElementVNode("div", null, [
      (_ctx.isProd())
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Production"))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Development"))
    ])
  ]))
}